import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';

const createHelpers = (width, height, css) => {
    // somehow sizes is ending up in markup, even if it is not a valid svg attribute
    // until we have a better solution, just render it empty, instead to '[Object object]'
    const sanitizeSizes = sizes =>
        Object.defineProperty(sizes, 'toString', {
            value: () => '',
            enumerable: false,
        });

    const getDimensions = (size, sizes) => {
        if (size && typeof size.width === 'number' && typeof size.height === 'number') {
            return size;
        }

        return size && sizes[size] ? sizes[size] : { width, height };
    };

    const getCss = (size, sizes, fillColor, fillColorRule, noStyles) => {
        if (noStyles) {
            return '';
        }

        const dimensions = getDimensions(size, sizes);
        const fillRule = fillColor && fillColorRule ? `${fillColorRule}{ fill: ${fillColor}; }` : '';

        return css`
            width: ${dimensions.width}px;
            height: ${dimensions.height}px;
            ${fillRule}
        `;
    };

    const propsToCss = ({ size, sizes, fillColor, fillColorRule, noStyles }) =>
        getCss(size, sizes, fillColor, fillColorRule, noStyles);

    return {
        getCss,
        getDimensions,
        propsToCss,
        sanitizeSizes,
    };
};

const width = '1024';
const height = '1024';
const viewBox = '0 0 1024 1024';

const { getDimensions, getCss, propsToCss, sanitizeSizes } = createHelpers(width, height, css);

const sizes = sanitizeSizes({
    small: { width: 16, height: 16 },
    medium: { width: 18, height: 18 },
    large: { width: 24, height: 24 },
});

const Image = styled.svg`
    ${propsToCss}
`;

const children = (
    <Fragment>
        <path
            d="M512 0C230.4 0 0 230.4 0 512s230.4 512 512 512 512-230.4 512-512S793.6 0 512 0zm0 921.6c-226.133 0-409.6-183.467-409.6-409.6S285.867 102.4 512 102.4 921.6 285.867 921.6 512 738.133 921.6 512 921.6zM695.467 256L512 439.467 328.533 256 256 328.533 439.467 512 256 695.467 328.533 768 512 584.533 695.467 768 768 695.467 584.533 512 768 328.533 695.467 256z"
            key="key-0"
        />
    </Fragment>
);

const defaultProps = {
    children,
    viewBox,
    fillColor: null,
    fillColorRule: '&&& path, &&& use, &&& g',
    sizes,
    size: null,
};

const propTypes = {
    fillColor: PropTypes.string,
    fillColorRule: PropTypes.string,
    viewBox: PropTypes.string.isRequired,
    children: PropTypes.node.isRequired,
    size: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.shape({
            height: PropTypes.number.isRequired,
            width: PropTypes.number.isRequired,
        }),
    ]),
    sizes: PropTypes.shape({
        height: PropTypes.number,
        width: PropTypes.number,
    }),
};

export default Object.assign(Image, {
    getDimensions,
    getCss,
    defaultProps,
    propTypes,
    displayName: 'ErrorCircle',
});
